module.exports = __webpack_public_path__ + "media/images/warning-4aa13adac66f599c5692fb406efa37f9.png";